export function sortByDate(data) {
  const sorted = [...data].sort((a, b) => {
    if (a.progress.dueDate && b.progress.dueDate) {
      return new Date(a.progress.dueDate) - new Date(b.progress.dueDate);
    }
    if (a.progress.startedAt && b.progress.startedAt) {
      return new Date(a.progress.startedAt) - new Date(b.progress.startedAt);
    }
    if (a.progress.dueDate) {
      return -1;
    }
    if (b.progress.dueDate) {
      return 1;
    }
    if (a.progress.startedAt) {
      return -1;
    }
    if (b.progress.startedAt) {
      return 1;
    }
    return new Date(a.createdAt) - new Date(b.createdAt);
  });
  return sorted;
}
